import { graphql } from 'react-relay';

import { commit } from '../../../mutations/commit';

const mutation = graphql`
  mutation updateInvoiceSettingsMutation($input: UpdateInvoiceSettingsInput!) {
    updateInvoiceSettings(input: $input) {
      invoiceSettings {
        ...BillingSettingsContainer_invoiceSettings
      }
      errors {
        key
        messages
      }
    }
  }
`;

const updateInvoiceSettings = (environment, params, args = {}) => {
  return commit(environment, {
    mutation,
    variables: {
      input: params,
    },
    ...args,
  });
};

export default updateInvoiceSettings;
